import Table from './tableComponents/Table';
import useTableContainer from './TableContainer';

export type TNormalTable = {
  data: any[];
  columns: any[];
  editEntryKey?: string;
  noResize?: boolean;
  onLoad?: () => void;
  pendingKey: string;
  formatData?: (data: any) => Record<string, any>;
};

const NormalTable = (props: TNormalTable) => {
  const { columns } = props;

  const tableProps = useTableContainer({ ...props, noActions: true });

  return columns?.length ? <Table {...tableProps} noResize={true} /> : null;
};

export default NormalTable;
